import { Stack, Typography } from '@mui/material';
import { AssortmentTagSelect } from '@retail/my-assortment/components';
import { AddButton, ExportToExcelButton } from '@retail/components';
import { usePermissionsForCurrentUser } from '@retail/app/stores/selected-context';
import { useAppTFunction } from '@retail/app/i18n';
import { AssortmentTag } from '@retail/my-assortment/types';
import { TagHeading } from '@shared/components';

interface Props {
  exportToExcel: () => Promise<void>;
  isLoadingExport: boolean;
  totalItems: number;
  assortmentTagSelect?: {
    assortmentTags: AssortmentTag[];
    selectedTags: AssortmentTag[] | null;
    selectTagById: (tagId: number) => void;
    resetTags: () => void;
  };
  onToggleAddItemsDialog: () => void;
}

export function AssortmentToolbar({
  exportToExcel,
  isLoadingExport,
  totalItems,
  assortmentTagSelect,
  onToggleAddItemsDialog,
}: Props) {
  const t = useAppTFunction();

  const { userCanCreate } = usePermissionsForCurrentUser();
  const canAddAssortmentItems = userCanCreate('ASSORTMENT_ITEMS');

  return (
    <Stack flexDirection="row" alignItems="center" justifyContent="space-between" pt={2} px={3}>
      <TagHeading>
        <Typography variant="h4">{t('products.mgItem.assortment')}</Typography>
      </TagHeading>
      <Stack flexDirection="row" gap={1.5} alignItems="center">
        {assortmentTagSelect && <AssortmentTagSelect {...assortmentTagSelect} />}
        <ExportToExcelButton
          disabled={totalItems === 0}
          loading={isLoadingExport}
          onClick={exportToExcel}
        />

        {canAddAssortmentItems && (
          <AddButton onClick={onToggleAddItemsDialog}>
            {t('myAssortment.actions.addItems')}
          </AddButton>
        )}
      </Stack>
    </Stack>
  );
}
